import { render } from "./ListeClientAffecter.vue?vue&type=template&id=28d6929d&ts=true"
import script from "./ListeClientAffecter.vue?vue&type=script&lang=ts"
export * from "./ListeClientAffecter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__